export default __webpack_public_path__ + "static/media/small_cv_sample1.7d42a8d2.png";